<label><input type="checkbox" [name]="name" [(ngModel)]="ngModelValue" [checked]="checked" [disabled]="disabled" [ngClass]="{'readonly': readonly}" /><span><ng-content></ng-content></span></label>
